import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getTermDeposits = (state: AppState) => state.termDepositTopUp;
const getListTopUp = (state: AppState) => state.termDepositTopUp.responseList;
const getDataCreate = (state: AppState) => state.termDepositTopUp.dataCreate;
const getResponseCreated = (state: AppState) => state.termDepositTopUp.responseCreate;
const getResponseConfirm = (state: AppState) => state.termDepositTopUp.responseConfirm;
const getResponseAuth = (state: AppState) => state.termDepositTopUp.responseAuth;

const getPending = (state: AppState) => state.termDepositTopUp.pending;

export const getTermDepositTopUpSelector = createSelector(getTermDeposits, (data) => data);
export const getTermDepositListTopUpSelector = createSelector(getListTopUp, (data) => data);

export const getTermDepositTopUpDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getTermDepositTopUpResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTermDepositTopUpResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTermDepositTopUpResponseAuthSelector = createSelector(getResponseAuth, (res) => res);

export const getTermDepositTopUpPendingSelector = createSelector(getPending, (status) => status);
